const fullWishlistPageFunction = (settingData) => {
  let th_shopify_shop = Shopify.shop;
   const thwlcGetCookie = (cname) => {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  // Shopify.money_format = "${{amount}}";
  Shopify.money_format = document.querySelector('.snippet-wishlist').getAttribute('data-money');
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
  function getWishlistItemsDetails(wishlistData) {
    if(wishlistData.data.total == 0){
      document.querySelector(".wishlist-items").innerHTML = "";
      if(document.querySelector(".wishlist-title") != null){
        document.querySelector(".wishlist-title").style.display = "flex"
      }
      if(document.querySelector(".wp-title") != null){
        document.querySelector(".wp-title").style.display = "flex"
      }
      if(document.querySelector(".wishlist-btn .th_wlc_product_count") != null){
        document.querySelector(".wishlist-btn .th_wlc_product_count").style.display = "none"
      }
      if(document.querySelector('.wishlist-items') != null){
        document.querySelector('.wishlist-items').innerHTML += '<p class="wishlist-empty">There is no product in your wishlist!</p>'
      }
    }
    // var $wishlistDatas = wishlistData.data.wishlists;
    // document.querySelector(".wishlist-count").innerHTML = wishlistData.data.total;
    // if(document.querySelector(".wishlist-btn span") != null){
    //   document.querySelector(".wishlist-btn span").innerHTML = wishlistData.data.total;
    // }
    // if(document.querySelector(".wishlist-inr") != null){
    //   document.querySelector(".wishlist-inr").setAttribute('data-val',wishlistData.data.total)
    // }
    // $wishlistDatas.forEach((e) => {
    //   var $getData = e.wishlists;
    //   $getData.forEach((data) => {
        
    //     var $protitle = data.title;
    //     var $removableId = data.id;
    //     var $proprice = data.price;
    //     var $proImage = data.image;
    //     var $wishlistId = data.wishlist_id;
    //     var $proId = data.shopify_product_id;
    //     var $proUrl = "/products/"+data.handle;
    //     var $variant = JSON.parse(data.variant);
    //     var $images = JSON.parse(data.images);
    //     if(Shopify.currency.active == 'GBP'){
    //       var $price = Math.round($variant.price * Shopify.currency.rate)
    //     }else{
    //       var $price = $variant.price * Shopify.currency.rate
    //     }
    //     var $final_price = $price * 100
    //     var addToCart = '';
    //     var disabled;
    //     if($variant.inventory_management == "shopify"){
    //       if($variant.inventory_quantity > 15 || $variant.product_id == 7478211477752 ){
    //         addToCart = 'Add to cart'
    //       }else{
    //         disabled = 'disabled';
    //         addToCart = 'Sold out'
    //       }
    //     }else{
    //       if($variant.inventory_quantity > 15 || $variant.product_id == 7478211477752){
    //         addToCart = 'Add to cart'
    //       }else{
    //         disabled = 'disabled';
    //         addToCart = 'Sold out'
    //       }
    //     }
    //     var appendHTML = `<div class="wishlist-column">
    //       <div class="snippet-product-grid">
    //         <button type="button" data-list="${$wishlistId}" data-id="${$removableId}" class="wishlist-remove">
    //           <svg class="svg-wishlist" xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none"><rect x="5.65837" y="6.72058" width="0.533333" height="15.4667" rx="0.266667" transform="rotate(-45 5.65837 6.72058)" fill="currentColor" stroke="currentColor" stroke-width="0.533333"></rect><rect x="16.5937" y="6.34343" width="0.533333" height="15.4667" rx="0.266667" transform="rotate(45 16.5937 6.34343)" fill="currentColor" stroke="currentColor" stroke-width="0.533333"></rect></svg>
    //         </button>
    //         <div class="grid-imagebox">
    //           <a href="${$proUrl}" class="product-link">
    //             <div class="product-images">
    //               <img src="${$images[0].src}" alt="${$protitle}" width="500" height="751" />
    //               ${$images[1] ? `<img src="${$images[1].src}" alt="${$protitle}" width="500" height="751" class="second-image" />` : ""}
    //             </div>
    //           </a>
    //         </div>
    //         <div class="grid-meta">
    //           <div class="grid-meta-inr">
    //             <p><a href="${$proUrl}">${$protitle}</a></p>
    //             <p class="body-12 grid-meta-price">${$variant.title}</p>
    //             <p class="body-12 grid-meta-price"><span class="money">${Shopify.formatMoney($final_price, Shopify.money_format)}</span></p>
    //           </div>
    //           <button class="wishlist-cart button button-full" data-id="${data.variant_id}" ${disabled}>
    //             <span>${addToCart}</span>
    //             <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none"><rect x="0.5" y="4" width="13.1667" height="11.9157" rx="2.5" stroke="currentColor"></rect><path d="M11.2047 4.33333V3.5992C11.2047 2.1637 10.041 1 8.60548 1H5.52889C4.09339 1 2.92969 2.1637 2.92969 3.5992V4.33333" stroke="currentColor"></path></svg>
    //           </button>
    //         </div>
    //       </div>
    //     </div>`;
    //     // ${wishlistData.data.setting.money_format,data.price}
    //     document.querySelector(".wishlist-items").innerHTML += appendHTML;
    //     if(document.querySelector('body.page-wishlist') == null){
    //       document.querySelector('body').classList.add('open-wishlist');
    //       document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-drawer');
    //     }
    //   })
    // })
  }
  window.removeProduct = async ($GetcustomerId, $GetId) => {
    var $GetIp = thwlcGetCookie("wlcIp");
    var $ShopUrl = Shopify.shop;
    if (!settingData) {
      settingData = JSON.parse(localStorage.getItem('th_default_settings_content'));
    }
    let data_json = JSON.stringify({ customer_id: $GetcustomerId, id: $GetId, ip: settingData ? settingData?.data?.ip : $GetIp, shop: $ShopUrl });
    const response = await fetch('https://wishlist.webcontrive.com/wishlist-club/public/api/v1/remove', {
      method: 'POST',
      body: data_json,
      headers: {
        'Content-Type': 'text/plain'
      }
    })
    const myJson = await response.json();
    if(myJson.status === 200){
      const payload = JSON.stringify({
        shop: $ShopUrl,
        customer_id: $GetcustomerId,
        ip: settingData ? settingData?.data?.ip : $GetIp
      });
      const response2 = await fetch("https://wishlist.webcontrive.com/wishlist-club/public/api/v1/get-setting", {
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'text/plain'
        }
      });
      const myJson2 = await response2.json();
      if(myJson2.status === 200){
        localStorage.setItem('th_wlc_pro_count', myJson2.data.total);
       // totalCountUpdate();
       
        getWishlistItemsDetails(myJson2);
       
      }
    }
  }
  $(document).on("click",".wishlist-remove",function(){
    var $GetcustomerId = Number($(".wishlist-items").attr('data-customer-id'));
    if($GetcustomerId == 0){
      $GetcustomerId = "";
    }
    var $GetId = Number($(this).attr("data-id"));
    removeProduct($GetcustomerId, $GetId);
  })
  window.$thGetWishlistJSON = async () => {
    var wlcIp = thwlcGetCookie("wlcIp") || "";
    var wlcShop = Shopify.shop;
    var wlcCustomer_id = (__st && __st.cid) || "";
    var urlParams = new URLSearchParams(window.location.search);
    var wlid = urlParams.get("wlid") || "";
    if (!settingData) {
      settingData = JSON.parse(localStorage.getItem('th_default_settings_content'));
    }
    var payload2 = JSON.stringify({
      shop: wlcShop,
      customer_id: wlcCustomer_id,
      ip: settingData ? settingData?.data?.ip : wlcIp,
      wishlist_share: wlid,
    });
    const $wc_GetWishlist_response = await fetch(wlcApiUrl+"/v1/get-setting", {
      method: "POST",
      body: payload2,
      headers: {
        "Content-Type": "application/json",
      },
    });
    const myJson = await $wc_GetWishlist_response.json();
    localStorage.setItem('th_wlc_pro_count', myJson.data.total);
  //  totalCountUpdate();
    if (typeof getWishlistItemsDetails == 'function') {
      getWishlistItemsDetails(myJson);
    }
    //return $wc_GetWishlist_response;
  }
  if(document.querySelector('body.page-wishlist') != null){
    setTimeout(function() {$thGetWishlistJSON()}, 1000);
  }
  document.querySelectorAll('.wishlist-btn').forEach(function(wishlistBtn){
    wishlistBtn.addEventListener('click',function(e){
      e.preventDefault();
      $thGetWishlistJSON();
    })
  })
  if(document.querySelector('.wishlist-overly') != null){
    document.querySelector('.wishlist-overly').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-wishlist');
    })
  }
  $(document).on('click','.wishlist-column .wishlist-cart',function(e){
    let id = this.getAttribute('data-id');
    const data = {quantity: 1, id: id}
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then((data) => {
      if(typeof load_cart == 'function'){
        cartNotification(data.id);
        load_cart();
      }else{
        window.location.href = "/cart";
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })
}
let settingData;
fullWishlistPageFunction(settingData);
// function th_recurse() {
//   if (typeof getLocalDetails == 'function') {
//     var settingData = JSON.parse(localStorage.getItem('th_default_settings_content'));
//     console.log('settingData', settingData);
//     fullWishlistPageFunction(settingData);
//   } else {
//    setTimeout(th_recurse, 100);   
//   }
// }
// th_recurse();
window.$th_wishlistAdd_callback_successMessage = (data) => {
  setTimeout(function(){
      const count = localStorage.getItem('th_wlc_pro_count');
      document.querySelectorAll('.th_wlc_product_count').forEach(function (self) {
          self.innerHTML = count ? count : '0';
      });
  }, 500);
}